import { useEffect } from 'react'

/** Sets the tab title: "Members · Halden · RowCall". */
export const useDocumentTitle = (...parts: (string | undefined)[]): void => {
  const title = [...parts.filter(Boolean), 'RowCall'].join(' · ')
  useEffect(() => {
    document.title = title
  }, [title])
}
